import { render } from "./GlobalDataSourceSelector.vue?vue&type=template&id=29fb056a&scoped=true"
import script from "./GlobalDataSourceSelector.vue?vue&type=script&lang=ts"
export * from "./GlobalDataSourceSelector.vue?vue&type=script&lang=ts"

import "./GlobalDataSourceSelector.vue?vue&type=style&index=0&id=29fb056a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-29fb056a"

export default script